import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DisplayValidationErrorsDirective } from '@curbnturf/form-helpers';
import { BookingFormComponent } from '@curbnturf/host-forms/src/lib/booking-form/booking-form.component';
import { ICheckInProcessType, IReservationProcessType } from '@curbnturf/objects';

@Component({
  selector: 'curbnturf-listing-booking',
  templateUrl: './listing-booking.component.html',
  styleUrls: ['./listing-booking.component.scss'],
  standalone: true,
  imports: [BookingFormComponent, DisplayValidationErrorsDirective],
})
export class ListingBookingComponent {
  @Input() form: FormGroup<{
    reservationProcess: FormControl<IReservationProcessType['type'] | null>;
    checkInProcess: FormControl<ICheckInProcessType['type'] | null>;
    checkIn: FormControl<string | null>;
    checkOut: FormControl<string | null>;
    nextReservationDiscount: FormControl<number | null>;
    minLengthOfStayInDays: FormControl<number | null>;
    maxLengthOfStayInDays: FormControl<number | null>;
    bookingWindow: FormControl<number | null>;
    reserveDaysInAdvance: FormControl<number | null>;
  }>;
}
